import { axios } from '@Api/axiosClient';
import type { CompanyInfo } from '@Types/dashboard.types';

const baseUrl = 'api/Company';

export const getCompanyInfoFromSessionApi = async (): Promise<CompanyInfo | null> => {
    const response = await axios.get(`${baseUrl}/GetCompanyInfoFromSession`);
    return response?.data ?? null;
};
